import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { FormattedText } from '#client/pages/EducationStudio/components/FormattedText/FormattedText';
import { FormattedTitle } from '#client/pages/EducationStudio/components/FormattedTitle/FormattedTitle';

export const StyledTitle = styled(FormattedTitle)(
  {
    marginBottom: '1.5rem'
  }
);

export const QuestionAnswer = ({ answer, question }) => {
  const questionText = `Q:  ${question}`;
  const answerText = `<b>A:</b> ${answer}`;

  return (
    <Box>
      <StyledTitle level={3} variant="mediumAlt" color="focus90" dirtyTitle={questionText} />
      <FormattedText dirtyText={answerText} />
    </Box>
  );
};

QuestionAnswer.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string
};
